import React from 'react';
import { StatCard, fmt$ } from './utils';

export default function StatsGrid({ backtest }) {
  const r = backtest.results || {};
  return (
    <div style={{ marginBottom: 'var(--space-5)' }}>
      {/* Headline metrics — the four numbers people judge a run by first. */}
      <div className="stat-grid stat-grid-headline" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: 'var(--space-3)',
        marginBottom: 'var(--space-3)',
      }}>
        <StatCard emphasis label="Return" value={r.return_pct != null ? `${r.return_pct}%` : '—'} color={r.return_pct >= 0 ? 'var(--green)' : 'var(--red)'} />
        <StatCard emphasis label="Sharpe Ratio" value={r.sharpe_ratio ?? '—'} />
        <StatCard emphasis label="Max Drawdown" value={r.max_drawdown_pct != null ? `${r.max_drawdown_pct}%` : '—'} />
        {r.excess_return_pct != null && (
          <StatCard emphasis label="Excess vs Buy & Hold" value={`${r.excess_return_pct >= 0 ? '+' : ''}${r.excess_return_pct}%`} color={r.excess_return_pct >= 0 ? 'var(--green)' : 'var(--red)'} />
        )}
      </div>

      {/* Secondary metrics. */}
      <div className="stat-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
        gap: 'var(--space-3)',
      }}>
        <StatCard label="Starting Value" value={fmt$(r.starting_value)} />
        <StatCard label="Ending Value" value={fmt$(r.ending_value)} />
        <StatCard label="Net Profit" value={fmt$(r.net_profit)} color={r.net_profit >= 0 ? 'var(--green)' : 'var(--red)'} />
        {r.benchmark_return_pct != null && (
          <StatCard label="Buy & Hold Return" value={`${r.benchmark_return_pct}%`} color={r.benchmark_return_pct >= 0 ? 'var(--green)' : 'var(--red)'} />
        )}
        {r.alpha_pct != null && <StatCard label="Alpha (annualized)" value={`${r.alpha_pct}%`} color={r.alpha_pct >= 0 ? 'var(--green)' : 'var(--red)'} />}
        {r.beta != null && <StatCard label="Beta" value={r.beta} />}
        <StatCard label="Total Trades" value={r.total_trades ?? '—'} />
        <StatCard label="Won / Lost" value={`${r.won_trades ?? 0} / ${r.lost_trades ?? 0}`} />
        <StatCard label="Slippage" value={r.slippage_pct != null ? `${r.slippage_pct}%` : '0.1%'} />
        <StatCard label="Commission" value={r.commission_pct != null ? `${r.commission_pct}%` : '0.1%'} />
        <StatCard label="Fill Mode" value={r.fill_on_close ? 'Bar Close' : 'Next Open'} />
        {r.total_commission_cost != null && <StatCard label="Total Commission" value={fmt$(r.total_commission_cost)} color="var(--red)" />}
        {r.total_slippage_cost != null && <StatCard label="Total Slippage" value={fmt$(r.total_slippage_cost)} color="var(--red)" />}
      </div>
    </div>
  );
}
